// Import library
import { createContext } from 'react';

export const OrgsContext = createContext([]);
